import React, { useState, useEffect } from "react";
import { Col, Image, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { ViewOpenIssuesTicketLeft } from "./ViewOpenIssuesTicketLeft";
import { ViewOpenIssuesTicketRight } from "./ViewOpenIssuesTicketRight";
import { useParams } from "react-router-dom";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import {
  getUserTicketDetailsFromIssueId,
  sendCommentForIssue,
  updateTicketStatus,
} from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const SuperAdminViewUsersTickets = (props) => {
  const [loading, setLoading] = useState(false);
  const { issueId } = useParams();
  //state
  const [showChat, setShowChat] = useState(false);
  const [showLog, setShowLog] = useState(true);
  const handleChatSHow = () => {
    setShowChat(true);
    setShowLog(false);
  };
  const handleLogSHow = () => {
    setShowLog(true);
    setShowChat(false);
  };
  const onSuccessGetTicketDetail = () => {
    setLoading(false);
    setMessage("");
  };

  const [message, setMessage] = useState("");
  const onClickAddComment = () => {
    const token = props.auth.user.accessToken;
    const formData = {};
    formData.comment = message;
    formData.comment_type = "TEXT";
    props.sendCommentForIssue(
      token,
      issueId,
      formData,
      onSuccessGetTicketDetail
    );
  };
  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.getUserTicketDetailsFromIssueId(
      issueId,
      token,
      onSuccessGetTicketDetail
    );
  }, []);
  const onSuccessChangeTicketStatus = (handleClose) => {
    handleClose();
    const token = props.auth.user.accessToken;
    props.getUserTicketDetailsFromIssueId(
      issueId,
      token,
      onSuccessGetTicketDetail
    );
  };
  const onErrorChangeTicketStatus = (handleClose) => {
    handleClose();
  };

  const onSubmitHandler = (status, handleClose) => (e) => {
    const token = props.auth.user.accessToken;
    const formData = {};
    formData.status = status;
    props.updateTicketStatus(
      token,
      formData,
      issueId,
      onSuccessChangeTicketStatus,
      onErrorChangeTicketStatus,
      handleClose
    );
  };
  return (
    <React.Fragment>
      {!loading ? <></> : <AmealioLoader />}
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Col className="d-flex flex-wrap pb-3">
              <Col md={6} className="pt-4">
                <NavLink to="/openissuesusers" className="f12-500 enBackLink">
                  <Image
                    fluid
                    alt="Back Icon"
                    title="Back Icon"
                    className="mr-2"
                    src={require("../../../../../assets/images/UserManagement/backIcon.svg")}
                  />
                  Back
                </NavLink>
                <div className="f24_700_HelveticaNeue">
                  Issue No :{" "}
                  {props.issueDetail && props.issueDetail.ticket_number}
                </div>
              </Col>
              <Col
                md={6}
                className="d-flex align-items-end justify-content-end"
              >
                {showLog && (
                  <Button
                    variant="danger"
                    className="btn2 btn-lg"
                    onClick={handleChatSHow}
                  >
                    Submit Response
                  </Button>
                )}
                {showChat && (
                  <Button
                    variant="danger"
                    className="btn2 btn-lg"
                    onClick={handleLogSHow}
                  >
                    View Log
                  </Button>
                )}
              </Col>
            </Col>
            <div className="super-admin-inside-right-side-panel pt-4 pb-4">
              <div className="row">
                <div className="col-lg-5 pr-lg-0">
                  <ViewOpenIssuesTicketLeft
                    issueDetails={props.issueDetail}
                    onSubmit={onSubmitHandler}
                    displayRestaurantDetails={true}
                  />
                </div>
                <div className="col-lg-7 pl-lg-2">
                  <ViewOpenIssuesTicketRight
                    auth={props.auth}
                    logData={props.issueDetail}
                    showLog={showLog}
                    showChat={showChat}
                    onClickShowLog={handleLogSHow}
                    onClickAddComment={onClickAddComment}
                    setMessage={setMessage}
                    message={message}
                    handleChatSHow={handleChatSHow}
                    actionBy="ADMIN"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

SuperAdminViewUsersTickets.propTypes = {
  auth: PropTypes.object.isRequired,
  getUserTicketDetailsFromIssueId: PropTypes.func.isRequired,
  sendCommentForIssue: PropTypes.func.isRequired,
  updateTicketStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  issueDetail: state.userManagement.issueDetail,
});

export default connect(mapStateToProps, {
  getUserTicketDetailsFromIssueId,
  sendCommentForIssue,
  updateTicketStatus,
})(SuperAdminViewUsersTickets);
